document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }

  
  // Remove código do Zepto Product Personalizer quando bloco está desabilitado
  const isPersonalizedProduct = document.querySelector('.personalized-product');
  
  
  // Função para remover elementos do Zepto
  function removeZeptoElements() {
    const customAppBlock = document.querySelector('.productView-moreItem-app-block-custom');
    

    
    if (!customAppBlock) {
      
      // Remove todos os elementos relacionados ao Zepto
      const selectors = [
        '[class*="zepto"]',
        '[class*="pplr"]',
        '[id*="zepto"]',
        '[id*="pplr"]',
        '[data-zepto]',
        '.product-personalizer',
        '#product-personalizer'
      ];
      
      selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
         
          element.remove();
        });
      });
    } else {
      
      // Se temos o bloco, remove apenas duplicatas FORA do nosso wrapper
      const allZeptoElements = document.querySelectorAll('[class*="zepto"]:not(.productView-moreItem-app-block-custom):not(.productView-moreItem-app-block-custom *)');
      console.log('🔍 DEBUG: Elementos Zepto duplicados:', allZeptoElements.length);
      
      allZeptoElements.forEach(element => {
        if (!customAppBlock.contains(element)) {
          
          element.remove();
        }
      });
    }
  }
  
  // Executa múltiplas vezes para garantir remoção (app pode injetar com delay)
  setTimeout(removeZeptoElements, 500);
  setTimeout(removeZeptoElements, 1500);
  setTimeout(removeZeptoElements, 3000);
  
  // Desabilita zoom em produtos personalizados
  if (!isPersonalizedProduct) {
    const imageContainers = document.querySelectorAll('.productView-image .productView-img-container');
    
    imageContainers.forEach(container => {
      const img = container.querySelector('img:not(.zoomImg)');
      
      if (img) {
        container.addEventListener('mousemove', function(e) {
          const rect = container.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          
          const xPercent = (x / rect.width) * 100;
          const yPercent = (y / rect.height) * 100;
          
          img.style.transformOrigin = xPercent + '% ' + yPercent + '%';
          img.style.transform = 'scale(1.15)';
        });
        
        container.addEventListener('mouseleave', function() {
          img.style.transform = 'scale(1)';
        });
      }
    });
  }
});